import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AFDirectorshipsDomain } from '../model/af.model';
import { AuthService } from './auth.service';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DirectorshipService {

  constructor(private readonly userService: AuthService, private readonly http: HttpClient) {
  }

  getDirectorShip(): Observable<AFDirectorshipsDomain> {
    return this.http.post<AFDirectorshipsDomain>(environment.api_uri + 'getDirectorShip', { 'verifyId': this.userService.getVerifyId() }).pipe(
      map(response => {

        response.afDirectorshipsList.forEach(item => {
          if (item.startDate) {
            item.startDate = new Date(item.startDate);
          }
          if (item.endDate) {
            item.endDate = new Date(item.endDate);
          }
          if (item.lastAccountFixedDate) {
            item.lastAccountFixedDate = new Date(item.lastAccountFixedDate);
          }
          if (item.status) {
            item.status = item.status + "";
          }
        });

        return response;
      }));
  }

  submitDirectorships(afDirectorshipsDomain: AFDirectorshipsDomain): Observable<AFDirectorshipsDomain> {
    const requestUrl = environment.api_uri + 'saveDirectorships';

    afDirectorshipsDomain.afDirectorshipsList.forEach(item => {
      if (item.startDate) {
        item.startDate = moment(item.startDate).format('MM/DD/YYYY');
      }

      if (item.endDate) {
        item.endDate = moment(item.endDate).format('MM/DD/YYYY');
      }

      if (item.lastAccountFixedDate) {
        item.lastAccountFixedDate = moment(item.lastAccountFixedDate).format('MM/DD/YYYY');
      }
    });

    return this.http.post<AFDirectorshipsDomain>(requestUrl, afDirectorshipsDomain);
  }
}